module.exports = __webpack_public_path__ + "img/Allec-New-Logo-K.635474bb.png";